var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cadfm-container-horizontal"},[(_vm.$route.params.view == 'DashboardWidgets')?_c('DashboardWidgets',{attrs:{"lang":_vm.lang.Dashboard.DashboardWidgets}}):_vm._e(),_vm._v(" "),(_vm.$route.params.view == 'DashboardTable')?_c('DashboardTable'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc31e16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Dashboard.vue
// module id = null
// module chunks = 